import { StageName, StageType } from "lib/types";
import { cn } from "lib/utils";
import React from "react";

const Stage = ({ stage, isFree }: { stage: number; isFree: boolean }) => {
  return (
    <div>
      <div
        className={cn(
          isFree
            ? "bg-red-600 text-xs"
            : stage === StageType.NONE
            ? "bg-[#dddddd]"
            : stage === StageType.CONTACT
            ? "bg-slate-300"
            : stage === StageType.VISIT_APPOINTMENT
            ? "bg-[#334bb5]"
            : stage === StageType.VISIT
            ? "bg-[#3962ca]"
            : stage === StageType.ESTIMATE
            ? "bg-[#5243b1]"
            : stage === StageType.CONTRACT_COMPLETED
            ? "bg-indigo-400"
            : stage === StageType.CLASS_ASSIGNED
            ? "bg-sky-500"
            : stage === StageType.CLASS_COMPLETED
            ? "bg-lime-600"
            : "bg-[#454545]",
          "text-white px-2 py-1 rounded-sm text-center mr-4"
        )}
      >
        {isFree && "무료"}
        {StageName[stage]}
      </div>
    </div>
  );
};

export default Stage;
